export default __webpack_public_path__ + "assets/wind-beaufort-11.d1d54bff.svg";